import { useMemo } from 'react';
import { Form, useScreenResolution } from 'dash-ui';
import { useTranslation } from 'react-i18next';

import { useGetAmenitiesQuery } from 'gql/generated.graphql';

const FeatureAndAmenitiesSelectInput = ({
  amenityIds,
  setAmenityIds,
}: {
  amenityIds?: string[];
  setAmenityIds: (amenityIds?: string[]) => void;
}) => {
  const {
    devices: { isDesktop },
  } = useScreenResolution();
  const { t } = useTranslation(['common', 'pages']);
  const { data, loading } = useGetAmenitiesQuery({
    fetchPolicy: 'network-only',
    variables: {
      filter: {
        isPrimary: true,
      },
      pagination: {
        allowLimit: false,
      },
    },
  });

  const options = useMemo(() => {
    const uniqAmenities = data?.getAmenities.collection || [];
    let sorted = [...uniqAmenities].sort((a, b) => {
      // First, compare the 'checked' property (true comes before false)
      if (amenityIds?.includes(a._id) === amenityIds?.includes(b._id)) {
        // If 'checked' values are the same, compare 'name' alphabetically
        return a.name.localeCompare(b.name);
      }

      // If 'a' is checked and 'b' is not, 'a' comes first
      return amenityIds?.includes(a._id) ? -1 : 1;
    });
    return sorted.map((item) => ({
      value: item._id,
      label: item.name,
    }));
  }, [data]);

  return (
    <Form.Group mb={5}>
      <Form.Label md>{t('common:labels.featuresAndAmenities')}</Form.Label>
      <Form.Select
        w="100%"
        isMulti
        disablePortalTarget={isDesktop}
        strictMenuWidth
        isLoading={loading}
        value={amenityIds}
        options={options}
        placeholder={t('common:placeholders.selectOption')}
        onChanged={(_: string, values?: string[]) => setAmenityIds(values)}
      />
    </Form.Group>
  );
};

export default FeatureAndAmenitiesSelectInput;
